module.exports = {
  menu: {
    home: "首頁",
    product: "產品和服務",
    aboutus: "關於我們",
    contactus: "聯繫我們",
    login: "商户/代理商登录"
  },
  select: {
    title: "選擇語言",
    lang: [
      {
        key: "zh-CN",
        name: "簡體中文"
      },
      {
        key: "zh-TW",
        name: "繁體中文"
      },
      {
        key: "en",
        name: "英語"
      },
      {
        key: "ja",
        name: "日語"
      },
      {
        key: "ko",
        name: "韓語"
      }
    ]
  },
  brandIntro: {
    title: "上海富惠網絡有限公司",
    slogan: "Slogan：以數字科技，賦能全球商業長效增長",
    intro: {
      title: "品牌簡介",
      paragraphs: [
        "Link2shops（上海富惠網絡有限公司）聚焦境內外企業數字化成長服務領域，是以銷售促成、會員增長等結果為核心導向的AI商業成長解決方案提供商。公司深度融合各類前沿大模型，將人工智能與數字化營銷、會員權益服務、全域獲客深度綁定，提供集系統研發、供應鏈協同、推廣分銷、精細化運營的全鏈路數字化解決方案，通過自研AI銷售系統，直擊企業拓客難、轉化低、人效不足的核心痛點，助力企業高效搭建拉新、促活、轉化、復購的閉環增長體系，讓技術落地真正轉化為業績增長與效率提升的實際成果。",
        "依託深厚的技術沉澱與行業實踐，公司率先落地自研核心產品AISalesPro AI銷售系統，以智能外呼（語音）/智能客服（線上）、意圖理解、異議處理、意向篩選、全流程促單的一體化銷售能力，替代傳統重複性人工工作，大幅降低企業運營成本、提升銷售轉化效率，實現AI技術與商業成長的深度落地融合，始終堅持「不為技術而技術，只為企業結果而服務」的核心理念。"
      ]
    },
    credentials: {
      title: "權威資質與技術保障",
      content:
        "作為國家認定高新技術企業、上海市專精特新中小企業，Link2shops技術體系與全平台服務系統，已通過PCI DSS支付卡行業數據安全認證、國家網絡安全等級保護三級認證等多項國內外權威安全及技術認證，以嚴苛合規標準築牢數據安全與業務信任防線，保障每一項智能服務、每一筆交易鏈路安全穩定、合規可溯。"
    },
    background: {
      title: "品牌背景與全球服務網絡",
      content:
        "由富友集團戰略投資，總部立足上海，在北京、武漢、香港、東京等地設立分支機構，全球服務網絡覆蓋中、日、韓、新、泰等多個國家與地區。深耕行業多年，已累計服務近300個知名品牌、超10000間線下門店，業務覆蓋餐飲購物、娛樂出行、金融權益、生活服務等多元商業場景，具備全球化、多場景、規模化的落地服務能力。"
    },
    ecosystem: {
      title: "全域生態夥伴矩陣",
      intro:
        "深度鏈接全球頂級商業生態資源，作為微信、支付寶、美團等主流流量平台官方服務商，助力企業高效打通公私域流量閉環；核心生態合作夥伴涵蓋：",
      categories: [
        {
          title: "金融機構",
          partners: ["Visa", "建行", "工行", "中行", "招行"]
        },
        {
          title: "航司與運營商",
          partners: ["春秋航空", "東方航空", "吉祥航空", "中國移動"]
        },
        {
          title: "全球商旅平台",
          partners: ["Booking", "Agoda", "攜程", "美團", "抖音"]
        }
      ]
    },
    aiStrategy: {
      title: "AI戰略佈局與長期價值",
      content:
        "公司將人工智能作為核心發展戰略，持續深耕大模型商用、智能營銷、企業效率數字化領域，不斷拓展AI產品矩陣。未來將圍繞企業全流程經營需求，陸續推出AI智能跟單、全域智能運營、團隊效率管理、數據化成長復盤等系列AI產品與解決方案，從前端智能獲客、中端業務轉化，到後端效率管控，全鏈路以AI科技賦能企業數字化升級，持續為全球商業夥伴實現降本增效、業績增收與長效穩健增長。"
    }
  },
  products: {
    servers: [
      {
        title: "分銷服務",
        subTitle: "為商戶提供一站式系統集成服務方案",
        desc:
          "Link2shops為海外商戶提供一站式的系統集成服務方案,幫助商戶將商品或服務快速預分銷至中國境內及部分國外的航空公司、銀行、OTA（在線旅行社）等渠道，並同時提供包括在線預訂、移動支付、顧客服務支持、市場推廣等服務，在為商戶增加銷售額的同時，為商戶提供銷售便利，提升品牌影響力。"
      },
      {
        title: "市場推廣服務",
        subTitle: "為商戶提供面向中國高端客戶的市場推廣服務",
        desc:
          "Link2shops是中國的銀行，航空公司，大型企業集團等知名平台的高端客戶權益提供商，能夠幫助商戶根據目標客戶類型，平台特點定制化市場活動，並將商戶信息發布推廣到相關平台，在吸引高端 客戶消費的同時，借平台的品牌影響力極大提升商戶自身品牌價值。"
      },
      {
        title: "零售系統軟件服務",
        subTitle: "為商戶提供零售系統軟件服務",
        desc:
          "Link2shops能夠為商戶提供以下系統軟件服務，包括：電子券系統（包含分銷，核銷），預訂訂座系統，收款系統（如支付寶，微信，蘋果支付）等。"
      }
    ]
  },
  company: {
    title: "合作夥伴",
    record: "沪ICP备17033610号-1",
    name: "上海富惠網絡有限公司",
    website: "網址",
    customer: "客戶服務",
    business: "商務合作",
    fax: "傳真",
    email: "電郵",
    address: "地址",
    addressDesc: "上海市浦東新區金藏路351號富友科技園6號樓2層",
    companyType1: "金融機構",
    companyType2: "商戶"
  },
  contact: {
    menu1: "聯繫我們",
    menu2: "商務合作"
  },
  about: {
    desc1:
      "Link2shops是上海富惠網絡有限公司針對境內外商戶打造的綜合系統服務品牌，旨在提供包括分銷、預定、推廣、支付等一體化解決方案。",
    desc2:
      "上海富惠網絡有限公司是由富友集團全資成立，在上海，北京，香港，東京設有子公司，分公司或辦事處。富友集團是國內知名金融集團，年業務規模8000億人民幣（約1150億美金），旗下9個全資子公司，具有包括第三方支付牌照在內的多個由中國人民銀行、中國國家外匯管理局等政府部門頒發的特許營運牌照。"
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/zh-TW.js